
import page from '@/components/page.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import wx from 'weixin-js-sdk'
import failimg from '@/assets/integralmall/timg.jpg'
import { getConfig } from '@/api/wx.js'
import config from '@/config/index'
import { getpjlist, updatePageViews, addTip } from '@/api/mall'
import Page from '../../components/page.vue'
export default {
directives: {
TransferDom
},
components: {
Popup,
Page
},
name: 'pingjialist',
props: {},
data () {
return {
productid: this.$route.params.id,
active: 4,
failimg: failimg,
baseUrl: config.baseUrl,
list: [],
num: '',
name: '宇宙无敌狂拽屌炸天',
times: 999,
show: false,
num1: '',
num2: '',
num3: '',
pageCurrent: 1,
pageSize: 4,
tempid: ''
}
},
created () {
this.getpjlistNow(1, '')
this.wxconfig()
},
activated () {
},
mounted () {
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['previewImage'] 
})
})
},

preview (index, fileList, pageViews, id) {
let arr = fileList.map(item => this.baseUrl + item)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
this.updatePageViewsNow(pageViews, id)
},
getpjlistNow (page, n) {
getpjlist({
productid: this.productid,
pageCurrent: page || 1,
pageSize: this.pageSize,
type: this.active
}).then(data => {
if (n != '') {
this.num = n
} else {
this.num = data.obj.num2 + data.obj.num3
}
this.list = this.list.concat(data.obj.newList)
this.num1 = data.obj.num1
this.num2 = data.obj.num2
this.num3 = data.obj.num3
})
},
updatePageViewsNow (pageViews, id) {
updatePageViews({
id: id,
pageViews: pageViews
})
},
choose (index, num) {
this.active = index
this.list = []
this.getpjlistNow(1, num)
},
jubao (id) {
this.show = true
this.tempid = id
},
cancel () {
this.show = false
this.tempid = ''
},
report (type) {
addTip({
staId: this.tempid,
type: type,
accountId: this.accountid
}).then(res => {
if (res.success) {
this.$vux.toast.text('举报成功', 'middle')
this.show = false
}
})
}
}
}
